module.exports = __webpack_public_path__ + "media/open_god_chest_old.80880d02.mp4";